import React from 'react';
import { ReactTyped } from 'react-typed';

const TypewriterEffect = ({ 
  strings = ["TransVie Diaspora"],
  typeSpeed = 100,
  backSpeed = 50,
  backDelay = 2000,
  loop = true,
  showCursor = true,
  cursorChar = "|",
  className = "",
  onComplete
}) => {
  return (
    <span className={className}>
      <ReactTyped
        strings={strings}
        typeSpeed={typeSpeed}
        backSpeed={backSpeed}
        backDelay={backDelay}
        loop={loop}
        showCursor={showCursor}
        cursorChar={cursorChar}
        {...(onComplete && { onComplete })}
      />
    </span>
  );
};

export default TypewriterEffect;
